var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKavachiconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.625L1.875 3.125V6.875C1.875 10.3438 4.275 13.5875 7.5 14.375C10.725 13.5875 13.125 10.3438 13.125 6.875V3.125L7.5 0.625ZM7.5 3.125L10.625 4.4875V6.875C10.625 9.0625 9.16875 11.1188 7.5 11.8313C5.83125 11.1188 4.375 9.0625 4.375 6.875V4.4875L7.5 3.125ZM6.875 5V7.5H8.125V5H6.875ZM6.875 8.75V10H8.125V8.75H6.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKavachiconnew);
export default __webpack_public_path__ + "static/media/kavachiconnew.41467c0bbc95bb74cdce8b21512c7ea6.svg";
export { ForwardRef as ReactComponent };